import { GetReports } from 'domain/usecases/reports/get-reports';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetAllReports extends BaseHttpService<GetReports.Model> implements GetReports {
  async getAll(params: GetReports.Params): Promise<GetReports.Model> {
    return await this.request('get', {}, params);
  }
}
